import { Typography, Box, Grid, Button } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import LockerLocationListTable from './LockerLocationTable';
import AddEditLockerLocationModal from './AddEditLockerLocationModal';
import { AppContext } from '../../contexts/AppContext';
import { ListAlt, Checklist } from '@mui/icons-material';

const LockerLocation = () => {

    const [open, setOpen] = useState(false)

    const [selectedItem, setSelectedItem] = useState<any | null>()
    const [lockerLocationList, setLockerLocationList] = useState<any | null>()
    const [count, setCount] = useState<any>(0);
    const [skip, setSkip] = useState<any>(0);
    const [take, setTake] = useState<any>(10);
    const [loading, setLoading] = useState<boolean>(false);
    const [showApproved, setShowApproved] = useState<string>('true');

    const { get } = useCrudForm();
    const { user } = useContext(AppContext)

    const refetch = ({ isMainTable }: { isMainTable: string }) => {
        setLoading(true)
        get({
            endpoints: `${endpoints.lockerLocation.list({ isMainTable: isMainTable, skip: skip * take, take })}`,
            onSuccess: (data: any) => {
                setLockerLocationList(data.data.list)
                setCount(data.data.count)
                setLoading(false)
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(false)
            }
        })
    }

    useEffect(() => {
        refetch({ isMainTable: showApproved });
    }, [skip, take])

    return (
        <>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>
                Locker Location Management
            </Typography>
            <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
                <Grid container spacing={1} style={{ marginBottom: "24px", display: 'flex', justifyContent: 'right' }}>
                    <Grid item>
                        <Button onClick={() => {
                            setSkip(0)
                            setTake(10)
                            setShowApproved('true')
                            refetch({ isMainTable: 'true' });
                        }} variant="contained" disabled={loading} sx={{ padding: '4px 8px', backgroundColor: showApproved === 'true' ? '#07bc0c' : '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: showApproved === 'true' ? '#07bc0c' : null } }}>
                            <ListAlt />
                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Approved List</Typography>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={() => {
                            setSkip(0)
                            setTake(10)
                            setShowApproved('false')
                            refetch({ isMainTable: 'false' });
                        }} variant="contained" disabled={loading} sx={{ padding: '4px 8px', backgroundColor: showApproved === 'false' ? '#07bc0c' : '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: showApproved === 'false' ? '#07bc0c' : null } }}>
                            <Checklist />
                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Need to Approve</Typography>
                        </Button>
                    </Grid>

                    {
                        (user?.role)?.toLowerCase() !== "checker" ? <Grid item>
                            <Button onClick={() => setOpen(true)} variant="contained" disabled={loading} sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                                <AddIcon />
                                <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>New Locker Location</Typography>
                            </Button>
                        </Grid> : null
                    }
                </Grid>
                <LockerLocationListTable loading={loading} setOpen={setOpen} setSelectedItem={setSelectedItem} rows={lockerLocationList} count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} setUpdateList={setLockerLocationList} refetch={refetch} showApproved={showApproved} />
            </Box>
            <AddEditLockerLocationModal open={open} setOpen={setOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setTableList={setLockerLocationList} refetch={refetch} showApproved={showApproved} setShowApproved={setShowApproved} setSkip={setSkip} setTake={setTake} />
        </>
    )
}

export default LockerLocation
